module.exports = __webpack_public_path__ + "static/img/time.c2de25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/time.png
// module id = 3hZI
// module chunks = 4